import { DefaultTextFieldComponent } from "@constellation-academy/framework-react-components";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { useTranslation } from "@i18n/hooks";
import { type AnswerOptionV2Input } from "../../../__generated__/CreateMultipleChoiceElementButton_CreateMultipleChoiceElementV2Mutation.graphql";
import {
	OfferFileSelectionField as FileSelectionField,
	type FileV2,
} from "../../../features/offer-files/offer-file-selection-field";

type OwnProps = {
	answerOption: AnswerOptionV2Input & { image?: FileV2 };
	onUpdate: (answerOption: AnswerOptionV2Input & { image?: FileV2 }) => void;
	onBack: () => void;
	canUploadFiles: boolean;
	canDeleteFiles: boolean;
};

export const EditAnswerOptionForm = ({
	answerOption,
	onUpdate,
	onBack,
	canUploadFiles,
	canDeleteFiles,
}: OwnProps) => {
	const { t } = useTranslation("common");
	return (
		<>
			<h3>{t("educationalOffer.editAnswer")}</h3>
			<DefaultTextFieldComponent
				fieldName={"answer"}
				fieldValue={answerOption.answer}
				updateField={(value) => {
					onUpdate({ ...answerOption, answer: value || "" });
				}}
				required={false}
				isValid={true}
				disabled={false}
			/>
			<div className="flex align-items-center mt-2 justify-content-between">
				<FileSelectionField
					name={"imageRef"}
					selectedFile={answerOption.image || undefined}
					setSelectedFile={(file) => {
						onUpdate({ ...answerOption, imageRef: file?.id, image: file });
					}}
					filterByFileTypes={["image/png", "image/jpg", "image/jpeg"]}
					canUploadFiles={canUploadFiles}
					canDeleteFiles={canDeleteFiles}
				/>
				<div className="p-field-checkbox flex align-items-center" style={{ minWidth: 150 }}>
					<Checkbox
						className="mr-2"
						inputId="item"
						onChange={(e) => {
							onUpdate({ ...answerOption, isCorrect: !!e.target.checked });
						}}
						checked={answerOption.isCorrect}
					/>
					<label htmlFor="city4">{t("educationalOffer.correctSelection")}</label>
				</div>
			</div>
			<Button
				type="button"
				onClick={onBack}
				label={t("educationalOffer.backToAnswers")}
				className="p-button-secondary mt-2"
			/>
		</>
	);
};
